export default "__VITE_ASSET__jBrYBmxD__"